// exclude-from-index
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import RichText from '../../RichText';
import { StyledCopyBody, StyledDefaultLabel, StyledToolTipContainer, StyledDescription } from './Label.styles';

class Label extends Component {
  static propTypes = {
    /** Label copy - displays beside form element */
    label: PropTypes.string,
    /** Description copy - displays below the label */
    description: PropTypes.string,
    /** Takes a ToolTip component and displays it beside the label */
    toolTip: PropTypes.node
  };

  static defaultProps = {
    label: undefined,
    description: undefined,
    toolTip: null
  };

  render() {
    const { label, description, toolTip } = this.props;

    return (
      <>
        {label &&
          (description ? (
            <>
              <StyledCopyBody weight="bold" noMargins>
                <RichText content={label} />
                {toolTip && <StyledToolTipContainer>{toolTip}</StyledToolTipContainer>}
              </StyledCopyBody>

              <StyledDescription noMargins>
                <RichText content={description} />
              </StyledDescription>
            </>
          ) : (
            <StyledDefaultLabel>
              <RichText content={label} />
              {toolTip && <StyledToolTipContainer>{toolTip}</StyledToolTipContainer>}
            </StyledDefaultLabel>
          ))}
      </>
    );
  }
}

export default Label;
